import { KeyValue } from "@angular/common";
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { throwError, Observable, catchError } from "rxjs";
import { environment } from "src/environments/environment";

@Injectable({ providedIn: 'root' })
export class ApiService {
  constructor(
    private http: HttpClient
  ) { }

  private formatErrors(error: any) {
    return throwError(() => error.error);
  }

  get(path: string, data: any = {}, props = {}): Observable<any> {
    let httpParams = new HttpParams();
    Object.keys(data).forEach(function (key) {
      var item = data[key]
      if (item != undefined && item != "undefined") {
        if (Array.isArray(item)) {
          for (var i = 0; i < item.length; i++) {
            httpParams = httpParams.append(key, item[i]);
          }
        }
        else {
          httpParams = httpParams.append(key, item);
        }
      }
    });

    return this.http.get(`${environment.apiUrl}${path}`, { ...props, params: httpParams })
  }

  put(path: string, body: Object = {}): Observable<any> {
    this.sanitizeBody(body);
    return this.http.put(
      `${environment.apiUrl}${path}`,
      // JSON.stringify(body)
    body
    );
  }

  post(path: string, body: Object = {}, options: any = {}): Observable<any> {
    this.sanitizeBody(body);
    return this.http.post(
      `${environment.apiUrl}${path}`,
      body,
      options
    );
  }

  formDataPost(url:string, formData: FormData): Observable<any> {
    return this.http.post(`${environment.apiUrl}${url}`, formData, {
      reportProgress: true,
      headers: new HttpHeaders({
        'Content-Type': 'multipart/form-data'
      })
    });
  }

  delete(path:any, body: any = null): Observable<any> {
    this.sanitizeBody(body);
    return this.http.delete(
      `${environment.apiUrl}${path}`,
      { body: body }
    );
  }

  private generateQueryParams(params: Array<KeyValue<string, any>>): HttpParams {
    var p = new HttpParams();
    for (let i = 0; i < params.length; i++) {
      let el = params[i];
      p = p.append(el.key, el.value ?? "");
    }

    return p;
  }

  private sanitizeBody(body: any): void {
    for (var param in body) {
      if (
        body[param] == undefined ||
        body[param] == null ||
        body[param] == "undefined" ||
        body[param] == "null"
      ) {
        delete body[param];
      }
    }
  }
}